export const CHANGE_THEME = 'CHANGE_THEME'
export const SET_THEME = 'SET_THEME'
export const GET_POKEMON_LIST = 'GET_POKEMON_LIST'
export const GET_POKEMON = 'GET_POKEMON'
export const ADD_POKEMON = 'ADD_POKEMON'
export const REMOVE_POKEMON = 'REMOVE_POKEMON'
export const ADD_TEAM = 'ADD_TEAM'
export const SET_USER = 'SET_USER'
export const CHANGE_VALUE = 'CHANGE_VALUE'